// services/cpq.js
import apiClient from './api';

/**
 * Fetches related CPQ data for a list of products.
 * Corresponds to: GET /api/products/cpq/:orgId/related-data
 */
export async function getCPQProductData(orgId, products, use_existing) {
  const response = await apiClient.post(`/products/cpq/${orgId}/related-data`, {
    products,
    use_existing,
  });
  return response.data;
}
/**
 * Fetches CPQ Product Rules.
 * Corresponds to: GET /api/products/cpq/:orgId/rules
 */
export async function getCPQProductRules(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/rules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Pricebooks.
 * Corresponds to: GET /api/products/cpq/:orgId/pricebooks
 */
export async function getCPQPricebooks(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/pricebooks`, { products });
  return response.data;
}

/**
 * Fetches CPQ Product Price Models.
 * Corresponds to: GET /api/products/cpq/:orgId/price-models
 */
export async function getCPQPriceModel(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/price-models`, { products });
  return response.data;
}

/**
 * Fetches CPQ Consumption Schedules.
 * Corresponds to: GET /api/products/cpq/:orgId/consumption-schedules
 */
export async function getCPQConsumptionSchedule(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/consumption-schedules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Discount Schedules.
 * Corresponds to: GET /api/products/cpq/:orgId/discount-schedules
 */
export async function getCPQDiscountSchedule(orgId, products) {
  const response = await apiClient.post(`/products/cpq/${orgId}/discount-schedules`, { products });
  return response.data;
}

/**
 * Fetches CPQ Price Rules for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/price-rules
 */
export async function getCPQPriceRules(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/price-rules`);
  return response.data;
}

/**
 * Fetches CPQ Quote Templates for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/quote-templates
 */
export async function getCPQQuoteTemplates(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/quote-templates`);
  return response.data;
}

/**
 * Fetches CPQ Product Attributes for a list of products.
 * Corresponds to: POST /api/products/cpq/:orgId/attributes
 */
export async function getCPQProductAttributes(orgId, products) {
  console.log(
    '[getCPQProductAttributes] Calling attributes/get-attributes endpoint for orgId:',
    orgId,
    'products:',
    products
  );
  const response = await apiClient.post(`/products/cpq/${orgId}/attributes/get-attributes`, { products });
  console.log('[getCPQProductAttributes] Response:', response.data);
  return response.data;
}

/**
 * Fetches CPQ Quote Terms for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/quote-terms
 */
export async function getCPQQuoteTerms(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/quote-terms`);
  return response.data;
}

/**
 * Fetches CPQ Guided Selling Processes for a specific org.
 * Corresponds to: GET /api/products/cpq/:orgId/guided-selling-process
 */
export async function getCPQGuidedSellingProcess(orgId) {
  const response = await apiClient.get(`/products/cpq/${orgId}/guided-selling-process`);
  return response.data;
}

/**
 * Saves CPQ Guided Selling Processes for a specific org.
 * Corresponds to: POST /api/products/cpq/:orgId/guided-selling-process/save
 */
export async function saveCPQGuidedSellingProcess(orgId, guidedSellingProcesses) {
  const response = await apiClient.post(`/products/cpq/${orgId}/guided-selling-process/save`, {
    guidedSellingProcesses,
  });
  return response.data;
}

/**
 * Deploys CPQ Pricing Rules to a specific org.
 * Corresponds to: POST /api/products/cpq/:orgId/deploy/pricing-rules
 */
export async function deployCPQPricingRules(orgId, pricingRules, orgData) {
  const response = await apiClient.post(`/products/cpq/${orgId}/deploy/pricing-rules`, {
    pricingRules,
    orgData,
  });
  return response.data;
}

/**
 * Deploys CPQ Quote Templates to a specific org.
 * Corresponds to: POST /api/products/cpq/:orgId/deploy/quote-templates
 */
export async function deployCPQQuoteTemplates(orgId, quoteTemplates, orgData) {
  const response = await apiClient.post(`/products/cpq/${orgId}/deploy/quote-templates`, {
    quoteTemplates,
    orgData,
  });
  return response.data;
}

/**
 * Deploys CPQ Guided Selling Processes to a specific org.
 * Corresponds to: POST /api/products/cpq/:orgId/deploy/guided-selling-processes
 */
export async function deployCPQGuidedSellingProcesses(orgId, guidedSellingProcesses, orgData) {
  const response = await apiClient.post(`/products/cpq/${orgId}/deploy/guided-selling-processes`, {
    guidedSellingProcesses,
    orgData,
  });
  return response.data;
}

/**
 * Deploys CPQ Quote Terms to a specific org.
 * Corresponds to: POST /api/products/cpq/:orgId/deploy/quote-terms
 */
export async function deployCPQQuoteTerms(orgId, quoteTerms, orgData) {
  const response = await apiClient.post(`/products/cpq/${orgId}/deploy/quote-terms`, {
    quoteTerms,
    orgData,
  });
  return response.data;
}
